export interface Region {
    regionId: number;
    name: string;
    districts: District[];
}

export interface District {
    districtId: number;
    name: string;
    suburbs: Suburb[];
}

export interface Suburb {
    suburbId: number;
    name: string;
}
